import { render } from "./GsbSelect.vue?vue&type=template&id=2f4e7520"
import script from "./GsbSelect.vue?vue&type=script&lang=js"
export * from "./GsbSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__